module.exports = __webpack_public_path__ + "img/newspic2.089076a0.jpg";